import { render, staticRenderFns } from "./OrganizationRole.vue?vue&type=template&id=055ffd08&scoped=true&"
import script from "./OrganizationRole.vue?vue&type=script&lang=js&"
export * from "./OrganizationRole.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationRole.vue?vue&type=style&index=0&id=055ffd08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055ffd08",
  null
  
)

export default component.exports